import React, { useState, useEffect } from "react";
import classes from "./AddProductsNew.module.css";
import Swal from "sweetalert2";
import api, { BASE_URL, getAuthHeaders } from "../../Components/API/Api";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useNavigate, useLocation } from "react-router-dom";
import { type } from "@testing-library/user-event/dist/type";

const AddLoanProductsNew = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isEdit = location.state?.isEdit || false;
  const editProduct = location.state?.product || null;
  const [formData, setFormData] = useState({
    product_name: editProduct?.loan_name || "",
    product_code: editProduct?.loan_code || "",
    product_type: editProduct?.loan_categogry || "",
    description: editProduct?.description || "",
    minimum_contribution: editProduct?.minimum_amount || "",
    maximum_contribution: editProduct?.max_amount || "",
    processing_fee: editProduct?.processing_fee || "",
    interest_rate: editProduct?.interest_rate || "",
    interest_type: editProduct?.interest_calculation || "",
    interest_frequency: editProduct?.interest_posting || "",
    minimum_tenure: editProduct?.min_tenure || "",
    maximum_tenure: editProduct?.max_tenure || "",
    repayment_method: editProduct?.repayement_method || "",
    minimum_membership_period: editProduct?.min_membership_period || "",
    minimum_age: editProduct?.min_savings_required || "",
    maximum_age: editProduct?.max_multiplier_savings || "",
    number_of_guarantors: editProduct?.required_guarantor_no || "",
    guarantor_approval: editProduct?.require_guarantor || "",
    manager_approval: editProduct?.manager_approval || "",
    committee_approval: editProduct?.committee_approval || "",
    board_approval: editProduct?.board_approval || "",
    cogs_account: editProduct?.asset_gl || "",
    income_account: editProduct?.income_gl || "",
    is_status: editProduct?.is_status === "1" || editProduct?.is_status === true || false,
  });
  const [logoDataUrl, setLogoDataUrl] = useState(editProduct?.image || "");
  const [logoFile, setLogoFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [incomeAccounts, setIncomeAccounts] = useState([]);
  const [cogsAccounts, setCogsAccounts] = useState([]);
  const [inventoryAccounts, setInventoryAccounts] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [receivableAccounts, setReceivableAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [stockClassifications, setStockClassifications] = useState([]);
  const [stockCategories, setStockCategories] = useState([]);
  const [stockDataLoading, setStockDataLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [storesLoading, setStoresLoading] = useState(false);
  // Add Category modal and integration states
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryDescription, setNewCategoryDescription] = useState("");
  const [isCreatingCategory, setIsCreatingCategory] = useState(false);

  // Fetch Income Accounts, COGS Accounts, Inventory Accounts, and Tax Types
  useEffect(() => {
    const fetchAccountsData = async () => {
      setAccountsLoading(true);
      const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

      const unwrapList = (res) =>
        Array.isArray(res?.data?.data)
          ? res.data.data
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.data?.accounts)
              ? res.data.accounts
              : [];

      const fetchList = async (label, url, withCompanyParam = true) => {
        try {
          const res = await api.get(url, withCompanyParam ? { params: { company_id: companyId } } : undefined);
          const list = unwrapList(res);
          console.log(`${label} response:`, res?.data);
          return list;
        } catch (err) {
          console.error(`${label} fetch failed:`, err?.response?.status, err?.response?.data || err?.message);
          return [];
        }
      };

      try {
        // Run account fetches independently so one failure doesn't block others.
        const [incomeList, cogsList, inventoryList, taxList, payableList, receivableList,] = await Promise.all([
          // fetchList("Income accounts", `/v1/get-income-accounts`),
          fetchList("Income accounts", `/v1/get-liability-accounts`),
          fetchList("COGS accounts", `/v1/get-expense-accounts`),
          fetchList("Inventory accounts", `/v1/get-cash-and-bank`),
          // fetchList("Inventory accounts", `/v1/get-inventory-accounts`),
          fetchList("Tax types", `/v1/get-asset-accounts`),
          fetchList("payable", `/v1/get-income-accounts`),
          fetchList("receivable", `/v1/get-suspense-accounts`),
        ]);

        setIncomeAccounts(payableList);
        setCogsAccounts(taxList);
        setInventoryAccounts(inventoryList);
        setTaxTypes(taxList);
        setPayableAccounts(payableList);
        setReceivableAccounts(receivableList);

        // Payable endpoint is sometimes sensitive to query shape, so retry without params if needed.
        // let payableList = await fetchList("Payable accounts", `/v1/get-payable-accounts`, true);
        // if (!payableList.length) {
        //   payableList = await fetchList("Payable accounts (fallback no params)", `/v1/get-payable-accounts`, false);
        // }

        // let receivableList = await fetchList("Receivable accounts", `/v1/get-receivable-accounts`, true);
        // if (!receivableList.length) {
        //   receivableList = await fetchList("Receivable accounts (fallback no params)", `/v1/get-receivables-accounts`, false);
        // }

        // setPayableAccounts(payableList);
        // setReceivableAccounts(receivableList);
        console.log("Payable Accounts Set:", payableList);
        console.log("Receivable Accounts Set:", receivableList);
      } catch (err) {
        console.error("Error fetching account data:", err);
      } finally {
        setAccountsLoading(false);
      }
    };

    fetchAccountsData();
  }, []);

  // Fetch Stock Classifications and Stock Categories
  useEffect(() => {
    const fetchStockData = async () => {
      setStockDataLoading(true);
      try {
        const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

        // Fetch Stock Classifications
        const classRes = await api.get(`/v1/fetch_stock_classification`, {
          params: { company_id: companyId }
        });
        if (classRes?.data?.data && Array.isArray(classRes.data.data)) {
          setStockClassifications(classRes.data.data);
        }

        // Fetch Stock Categories
        const catRes = await api.get(`/v1/stock_category`, {
          params: { company_id: companyId }
        });
        if (catRes?.data?.data && Array.isArray(catRes.data.data)) {
          setStockCategories(catRes.data.data);
        }
      } catch (err) {
        console.error("Error fetching stock data:", err);
      } finally {
        setStockDataLoading(false);
      }
    };

    fetchStockData();
  }, []);

  // Fetch Stores for Warehouse field
  useEffect(() => {
    const fetchStores = async () => {
      setStoresLoading(true);
      try {
        const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
        const res = await api.get(`/v1/store`, {
          params: { company_id: companyId }
        });
        if (res?.data?.data && Array.isArray(res.data.data)) {
          setStores(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching stores:", err);
      } finally {
        setStoresLoading(false);
      }
    };

    fetchStores();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({
      ...p,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
      alert("File too large — max 2MB");
      return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
      setLogoDataUrl(String(ev.target?.result || ""));
      setLogoFile(file);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveLogo = () => {
    setLogoDataUrl("");
    setLogoFile(null);
  };

  const openAddCategoryModal = () => {
    setNewCategoryName("");
    setNewCategoryDescription("");
    setShowAddCategoryModal(true);
  };

  const handleCreateCategory = async () => {
    if (!newCategoryName || !newCategoryName.trim()) {
      Swal.fire({ icon: 'warning', title: 'Name required', text: 'Please provide a category name.' });
      return;
    }
    setIsCreatingCategory(true);
    try {
      const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
      const payload = { 
        name: newCategoryName.trim(), 
        description: newCategoryDescription,
        company_id: companyId
      };
      const response = await api.post(
        `/v1/stock_category/create`,
        payload
      );

      const created = response?.data?.data || response?.data || null;
      if (response?.data?.status && created) {
        const newCat = Array.isArray(created) ? created[0] : created;
        setStockCategories(prev => Array.isArray(prev) ? [...prev, newCat] : [newCat]);
        setFormData(prev => ({ ...prev, stock_category: newCat.id }));
        Swal.fire({ icon: 'success', title: 'Category created', text: `Category "${newCat.name || newCategoryName}" created successfully.` });
        setShowAddCategoryModal(false);
      } else {
        Swal.fire({ icon: 'error', title: 'Creation failed', text: response?.data?.message || 'Failed to create category.' });
      }
    } catch (err) {
      console.error('Error creating category:', err);
      Swal.fire({ icon: 'error', title: 'Error', text: err?.response?.data?.message || err?.message || 'Failed to create category.' });
    } finally {
      setIsCreatingCategory(false);
    }
  };

  const validateOld = () => {
    const required = [
      typeof formData.product_type === "1" ? "product_name" : "product_code" === "1" ? "product_code" : "product_name",
      "product_name",
      "product_code",
      "product_type",
      "category",
      "cost_price",
      "selling_price",
      "minimum_price",
      "wholesale_price",
      "opening_stock",
      "reorder_level",
      "unit",
      "income_account",
      "cogs_account",
      "stock_classification",
      "stock_category",
    ];
    const missing = required.filter((k) => !String(formData[k] || "").trim());
    return missing;
  };

const validate = () => {
  let required = [];

  if (Number(formData.product_type) === 1) {
    // Only validate these fields
    required = [
      "description",
      "income_account",
      "cogs_account",
      "receivable_account",
      "payable_account",
      // "tax_type",
    ];
  } else {
    // Validate all fields
    required = [
      "product_name",
      // "product_code",
      "product_type",
      // "category",
      "cost_price",
      "selling_price",
      "minimum_price",
      "wholesale_price",
      "opening_stock",
      "reorder_level",
      "unit",
      "income_account",
      "cogs_account",
      "stock_classification",
      "stock_category",
    ];
  }

  const missing = required.filter(
    (k) => !String(formData[k] || "").trim()
  );

  return missing;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    // const missing = validate();
    // if (missing.length) {
    //   return Swal.fire({
    //     icon: "error",
    //     title: "Missing fields",
    //     text: `Please fill: ${missing.join(", ")}`,
    //     confirmButtonColor: "#0a7d3b",
    //   });
    // }

    setSaving(true);
    try {
      const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

      // Create FormData for multipart upload (needed for image)
      const fd = new FormData();

      // if (Number(formData.product_type) === 1) {
      //   fd.append("company_id", String(companyId));
      //   fd.append("type", formData.product_type || "");
      //   fd.append("payable_gl", formData.payable_account || "");
      //   fd.append("account_receivable", formData.receivable_account || "");
      //   fd.append("description", formData.description || "");
      //   fd.append("name", formData.product_name);     
      //   fd.append("income_account", String(formData.income_account));
      //   fd.append("cost_of_good_gl", String(formData.cogs_account));
      //   fd.append("warehouse", formData.warehouse || "");
      //   fd.append("store_id", formData.warehouse || "");
      // } else {
      //   fd.append("name", formData.product_name);
      //   fd.append("short_name", formData.product_code?.substring(0, 10) || "");
      //   fd.append("description", formData.description || "");
      //   fd.append("product_code", formData.product_code);
      //   fd.append("unit_price", String(formData.selling_price));
      //   fd.append("price", String(formData.selling_price));
      //   fd.append("cost_price", String(formData.cost_price));
      //   fd.append("minimum_price", String(formData.minimum_price));
      //   fd.append("wholesale_price", String(formData.wholesale_price));
      //   fd.append("quantity", String(formData.opening_stock));
      //   fd.append("stock_classification", String(formData.stock_classification));
      //   fd.append("stock_category", String(formData.stock_category));
      //   fd.append("unit_of_measurement", formData.unit);
      //   fd.append("re_order_level", String(formData.reorder_level));
      //   fd.append("company_id", String(companyId));
      //   fd.append("store_id", formData.warehouse || "");
      //   fd.append("income_account", String(formData.income_account));
      //   fd.append("cost_of_good_gl", String(formData.cogs_account));
      //   fd.append("inventory_gl", formData.inventory_account || "");
      //   fd.append("warehouse", formData.warehouse || "");
      //   fd.append("is_manufactured", formData.is_manufactured ? "1" : "0");
      //   fd.append("tax", formData.tax_type || "");
      //   fd.append("payable_gl", formData.payable_account || "");
      //   fd.append("account_receivable", formData.receivable_account || "");
      //   fd.append("type", formData.product_type || "");
      // }

      // Map form fields to backend parameter names
      fd.append("company_id", String(companyId));
      fd.append("loan_code", formData.product_code);
      fd.append("loan_name", formData.product_name);
      // fd.append("loan_category", formData.product_type || "");
      fd.append("description", formData.description || "");
      fd.append("minimum_amount", String(formData.minimum_contribution) || "");
      fd.append("max_amount", String(formData.maximum_contribution) || "");
      fd.append("processing_fee", formData.processing_fee || "");
      fd.append("interest_rate", String(formData.interest_rate) || "");
      fd.append("interest_type", formData.interest_calculation || "");
      fd.append("interest_frequency", formData.interest_posting || "");
      fd.append("min_tenure", String(formData.minimum_tenure) || "");
      fd.append("max_tenure", formData.maximum_tenure || "");
      fd.append("repayement_method", formData.repayment_method || "");
      fd.append("min_membership_period", formData.minimum_membership_period || "");
      fd.append("min_savings_required", formData.minimum_age || "");
      fd.append("max_multiplier_savings", formData.maximum_age || "");
      fd.append("required_guarantor_no", formData.number_of_guarantors || "");
      fd.append("require_guarantor", String(formData.guarantor_approval) || "");
      fd.append("manager_approval", String(formData.manager_approval) || "");
      fd.append("committee_approval", String(formData.committee_approval) || "");
      fd.append("board_approval", String(formData.board_approval) || "");
      fd.append("asset_gl", String(formData.cogs_account) || "");
      fd.append("income_gl", String(formData.income_account) || "");
      fd.append("status", formData.is_status ? "1" : "0");
      // fd.append("store_id", formData.warehouse || "");
      // fd.append("interest_expense_gl", String(formData.cogs_account));
      // fd.append("cash_bank_gl", formData.inventory_account || "");
      // fd.append("withdrawal_gl", formData.tax_type || "");
      // fd.append("penalty_income_gl", formData.payable_account || "");
      // fd.append("suspense_gl", formData.receivable_account || "");

      // Add image if present
      if (logoFile) {
        fd.append("image", logoFile);
      }

      let res;
      let successMessage;

      if (isEdit) {
        // Update endpoint
        fd.append("id", editProduct.id);
        res = await api.post(`/v1/update_stock`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        successMessage = "Product updated successfully.";
      } else {
        // Create endpoint
        res = await api.post(`/v1/loan_account/create`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        successMessage = "Product created successfully.";
      }

      const ok = res?.data?.status === true || res?.data?.success === true;
      if (ok) {
        await Swal.fire({
          icon: "success",
          title: isEdit ? "updated" : "Saved",
          text: res?.data?.message || successMessage,
          confirmButtonColor: "#0a7d3b",
        });
        navigate("/setup/loan-products");
      } else {
        const msg = res?.data?.message;
        const text = typeof msg === "string" ? msg : JSON.stringify(msg);
        await Swal.fire({ icon: "error", title: "Failed", text: text || (isEdit ? "Could not update product." : "Could not create product."), confirmButtonColor: "#0a7d3b" });
      }
    } catch (err) {
      const serverMsg = err?.response?.data?.message || err?.message;
      await Swal.fire({ icon: "error", title: "Error", text: JSON.stringify(serverMsg), confirmButtonColor: "#0a7d3b" });
    } finally {
      setSaving(false);
    }
  };

  const handleCancelew = () => {
    // window.confirm("Discard changes and go back?") && 
    navigate(-1);
  };

    const handleCancel = async () => {
      const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: 'Discard changes and go back?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2d995f',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, discard!',
      cancelButtonText: 'No, cancel',
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }
    navigate(-1);
  };

  return (
    <>
      <HeaderNav />
      <div className={classes.bredcrmb}>
        {/* <div className={classes.actionshe}>
          <button
            className={classes.btns}
            onClick={() => navigate("/transactions/sales-invoice/sale")}
          >
            Sales Invoice
          </button>
          <button className={classes.btns} onClick={() => navigate("/inventory/purchaseOrder")}> Purchase Invoice</button>
          <button className={classes.btns} onClick={() => navigate("/inventory/stocks_delivery")}>Stock Delivary</button>
          <button className={`${classes.btnss} ${classes.greens}`}>Product & Services </button>
        </div> */}

        <header className={classes.Header}>
          <h2 className={classes.Title}>Loan Product Setup</h2>
          <h1 className={classes.Titles}>
            Create and Configure Cooperative Loan Products
          </h1>
        </header>
      </div>
      
      {/* <div className={classes.header}>
        <h2>➕ Add Product</h2>
      </div> */}

      <div className={classes.container}>
        
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className={classes.card}>
            {/* <h3>{isEdit ? "Edit Product/Service" : "Add Product/Service"}</h3> */}

            {/* BASIC INFORMATION */}
            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Product Information
              </div>
              <div class="card-body">
                  <div className={classes.grid2}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="product_code">Loan Code</label>
                      <input
                        id="product_code"
                        name="product_code"
                        type="text"
                        value={formData.product_code}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="product_name">Loan Name</label>
                      <input
                        id="product_name"
                        name="product_name"
                        type="text"
                        value={formData.product_name}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    {/* <div className={classes.inputGroup}>
                      <label htmlFor="selling_price">Product Type</label>
                      <input
                        id="selling_price"
                        name="selling_price"
                        type="number"
                        value={formData.selling_price}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div> */}
                    {/* <div className={classes.inputGroup}>
                      <label htmlFor="product_type">Loan Category</label>
                      <select
                        id="product_type"
                        name="product_type"
                        value={formData.product_type}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select Category</option>
                        <option value="Personal Loan">Personal Loan</option>
                        <option value="Emergency Loan">Emergency Loan</option>
                        <option value="Housing Loan">Housing Loan</option>
                        <option value="Education Loan">Education Loan</option>
                        <option value="Asset Loan">Asset Loan</option>
                      </select>
                    </div> */}
                  </div>
                  <div className={classes.inputGroup} style={{ marginTop: 20, marginBottom: 20 }}>
                    <label htmlFor="description">Description</label>
                    <textarea
                      id="description"
                      name="description"
                      rows="3"
                      value={formData.description}
                      onChange={handleChange}
                      // disabled={formData.product_type === ""}                  
                    ></textarea>
                  </div>
              </div>
            </div>

            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Loan Amount Configuration
              </div>
              <div class="card-body">
                  <div className={classes.grid}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="minimum_contribution">Minimum Amount</label>
                      <input
                        id="minimum_contribution"
                        name="minimum_contribution"
                        type="text"
                        value={formData.minimum_contribution}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="maximum_contribution">Maximum Amount</label>
                      <input
                        id="maximum_contribution"
                        name="maximum_contribution"
                        type="number"
                        value={formData.maximum_contribution}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="processing_fee">Processing Fee (%)</label>
                      <input
                        id="processing_fee"
                        name="processing_fee"
                        type="number"
                        value={formData.processing_fee}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                  </div>
              </div>
            </div>

            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Interest Configuration 
              </div>
              <div class="card-body">
                  <div className={classes.grid}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="interest_rate">Interest Rate (%)</label>
                      <input
                        id="interest_rate"
                        name="interest_rate"
                        type="text"
                        value={formData.interest_rate}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="interest_calculation">Interest Type</label>
                      <select
                        id="interest_calculation"
                        name="interest_calculation"
                        value={formData.interest_calculation}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="Flat Rate">Flat Rate</option>
                        <option value="Reducing Balance">Reducing Balance</option>
                      </select>
                    </div>                    
                    <div className={classes.inputGroup}>
                      <label htmlFor="interest_posting">Interest Frequency</label>
                      <select
                        id="interest_posting"
                        name="interest_posting"
                        value={formData.interest_posting}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Yearly">Yearly</option>
                      </select>
                    </div>
                  </div>
              </div>
            </div>

            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Repayment Configuration
              </div>
              <div class="card-body">
                  <div className={classes.grid}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="minimum_tenure">Minimum Tenure (Months)</label>
                      <input
                        id="minimum_tenure"
                        name="minimum_tenure"
                        type="text"
                        value={formData.minimum_tenure}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="maximum_tenure">Maximum Tenure (Months)</label>
                      <input
                        id="maximum_tenure"
                        name="maximum_tenure"
                        type="number"
                        value={formData.maximum_tenure}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="repayment_method">Repayment Method</label>
                      <select
                        id="repayment_method"
                        name="repayment_method"
                        value={formData.repayment_method}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select Type</option>
                        <option value="Salary Deduction">Salary Deduction</option>
                        <option value="Direct Payment">Direct Payment</option>
                        <option value="Bank Transfer">Bank Transfer</option>
                      </select>
                    </div>
                  </div>
              </div>
            </div>
            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}} >
              Accounting (GL Mapping)
              </div>
              <div class="card-body">
                  <div className={classes.grid2}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="cogs_account">Loan Account GL</label>
                      <select
                        id="cogs_account"
                        name="cogs_account"
                        value={formData.cogs_account}
                        onChange={handleChange}
                        // disabled={accountsLoading || formData.product_type === ""}
                      >
                        <option value="">Select Loan Account GL</option>
                        {cogsAccounts.map((account) => (
                          <option key={account.id} value={account.id}>
                            {account.gl_name || account.name || account.account_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="income_account">Interest Income GL</label>
                      <select
                        id="income_account"
                        name="income_account"
                        value={formData.income_account}
                        onChange={handleChange}
                        // disabled={accountsLoading || formData.product_type === ""}
                      >
                        <option value="">Select Interest Income GL</option>
                        {incomeAccounts.map((account) => (
                          <option key={account.id} value={account.id}>
                            {account.gl_name || account.name || account.account_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className={classes.inputGroup}>
                      <label htmlFor="inventory_account">Cash/Bank GL</label>
                      <select
                        id="inventory_account"
                        name="inventory_account"
                        value={formData.inventory_account}
                        onChange={handleChange}
                        // disabled={accountsLoading || formData.product_type === ""}
                      >
                        <option value="">Select Cash/Bank GL</option>
                        {inventoryAccounts.map((account) => (
                          <option key={account.id} value={account.id}>
                            {account.gl_name || account.name || account.account_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="tax_type">Withdrawal GL</label>
                      <select
                        id="tax_type"
                        name="tax_type"
                        value={formData.tax_type}
                        onChange={handleChange}
                        // disabled={accountsLoading || formData.product_type === ""}
                      >
                        <option value="">Select Withdrawal GL</option>
                        {taxTypes.map((tax) => (
                          <option key={tax.id} value={tax.id}>
                            {tax.description || tax.name || tax.short_name || tax.gl_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="payable_account">Penalty Income GL</label>
                      <select
                        id="payable_account"
                        name="payable_account"
                        value={formData.payable_account}
                        onChange={handleChange}
                        // disabled={accountsLoading || formData.product_type === ""}
                      >
                        <option value="">Select Penalty Income GL</option>
                        {payableAccounts.map((account) => (
                          <option
                            key={account.id || account.gl_name}
                            value={account.id || ""}
                          >
                            {account.gl_name || ""}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="receivable_account">Suspense GL</label>
                      <select
                        id="receivable_account"
                        name="receivable_account"
                        value={formData.receivable_account}
                        onChange={handleChange}
                        // disabled={accountsLoading || formData.product_type === ""}
                      >
                        <option value="">Select Suspense GL</option>
                        {receivableAccounts.map((account) => (
                          <option
                            key={account.id || account.gl_name}
                            value={account.id || ""}
                          >
                            {account.gl_name || ""}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
              </div>
            </div>

            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}} >
              Eligibility Rules
              </div>
              <div class="card-body">
                  <div className={classes.grid}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="minimum_membership_period">Minimum Membership Period (Months)</label>
                      <input
                        id="minimum_membership_period"
                        name="minimum_membership_period"
                        type="number"
                        value={formData.minimum_membership_period}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="minimum_age">Minimum Savings Required</label>
                      <input
                        id="minimum_age"
                        name="minimum_age"
                        type="number"
                        value={formData.minimum_age}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="maximum_age">Maximum Multiplier of Savings</label>
                      <input
                        id="maximum_age"
                        name="maximum_age"
                        type="number"
                        value={formData.maximum_age}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                  </div>
              </div>
            </div>

            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Guarantor Requirements
              </div>
              <div class="card-body">
                  <div className={classes.grid2}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="number_of_guarantors">Number of Guarantors Required</label>
                      <input
                        id="number_of_guarantors"
                        name="number_of_guarantors"
                        type="number"
                        value={formData.number_of_guarantors}
                        onChange={handleChange}
                        // disabled={formData.product_type === "1" || formData.product_type === ""}
                        // required
                      />
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="guarantor_approval">Require Guarantor Approval?</label>
                      <select
                        id="guarantor_approval"
                        name="guarantor_approval"
                        value={formData.guarantor_approval}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select</option>
                        <option value="1">Yes</option>
                        <option value="2">No</option>
                      </select>
                    </div>
                  </div>
              </div>
            </div>

            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Approval Workflow
              </div>
              <div class="card-body">
                  <div className={classes.grid}>
                    <div className={classes.inputGroup}>
                      <label htmlFor="manager_approval">Manager Approval</label>
                      <select
                        id="manager_approval"
                        name="manager_approval"
                        value={formData.manager_approval}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select</option>
                        <option value="1">Required</option>
                        <option value="2">Not Required</option>
                      </select>
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="committee_approval">Committee Approval</label>
                      <select
                        id="committee_approval"
                        name="committee_approval"
                        value={formData.committee_approval}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select</option>
                        <option value="1">Required</option>
                        <option value="2">Not Required</option>
                      </select>
                    </div>
                    <div className={classes.inputGroup}>
                      <label htmlFor="board_approval">Board Approval</label>
                      <select
                        id="board_approval"
                        name="board_approval"
                        value={formData.board_approval}
                        onChange={handleChange}
                        // disabled={isEdit}
                        required
                      >
                        <option value="">Select</option>
                        <option value="1">Required</option>
                        <option value="2">Not Required</option>
                      </select>
                    </div>
                  </div>
              </div>
            </div>


            <div class="card mb-4">
              <div class="card-header" style={{fontWeight: "bold"}}>
              Status
              </div>
              <div class="card-body">
                  <div className={classes.grid}>
                    <div>
                        <input 
                          class="form-check-input" type="checkbox" 
                          id="is_status"
                          name="is_status"
                          checked={formData.is_status}
                          onChange={handleChange}
                          // disabled={formData.product_type === "1" || formData.product_type === ""}
                        />
                        <label class="form-check-label">Active Loan Product</label>
                    </div>
                  </div>
              </div>
            </div>

            <div className={classes.footer}>
              <div className={classes.actions}>
                <button type="button" onClick={handleCancel} className={`${classes.btn} ${classes.btnGhost}`}>
                  Cancel
                </button>
                <button type="submit" className={`${classes.btn} ${classes.btnPrimary}`} disabled={saving}>
                  {saving ? (isEdit ? "Updating..." : "Saving...") : (isEdit ? "Update Loan Product" : "Save Loan Product")}
                </button>
              </div>
            </div>

            {/* Add Stock Category Modal */}
            {showAddCategoryModal && (
              <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                <div style={{ background: '#fff', padding: '1.25rem', borderRadius: 8, width: '420px', boxShadow: '0 6px 18px rgba(0,0,0,0.2)' }}>
                  <h3 style={{ marginTop: 0 }}>Add Stock Category</h3>
                  <div style={{ marginBottom: '0.75rem' }}>
                    <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>Name</label>
                    <input
                      type="text"
                      value={newCategoryName}
                      onChange={(e) => setNewCategoryName(e.target.value)}
                      style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: 4 }}
                    />
                  </div>
                  <div style={{ marginBottom: '0.75rem' }}>
                    <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>Description</label>
                    <textarea
                      value={newCategoryDescription}
                      onChange={(e) => setNewCategoryDescription(e.target.value)}
                      rows={3}
                      style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: 4 }}
                    />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <button type="button" className={classes.btn} onClick={() => setShowAddCategoryModal(false)} disabled={isCreatingCategory} style={{ backgroundColor: '#f0f0f0', color: '#333' }}>
                      Cancel
                    </button>
                    <button
                      type="button"
                      className={classes.btn}
                      onClick={handleCreateCategory}
                      disabled={isCreatingCategory}
                      style={{ backgroundColor: '#0a7d3b', color: '#fff' }}
                    >
                      {isCreatingCategory ? 'Creating...' : 'Create'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default AddLoanProductsNew;
